import React, { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { Link } from 'gatsby';
import Arrow from '/src/components/arrow';

const Accessible = () => {
	const { t } = useTranslation(null, { keyPrefix: 'home-page.accessible' });

	const [selectedIdx, setSelectedIdx] = useState(0);

	const phases = useMemo(() => [{
		label: t('phase-one'),
		heading: t('dash-cam'),
		description: t('as-our-base'),
		link: '/dash-cam',
	}, {
		label: t('phase-two'),
		heading: t('ai-safety'),
		description: t('layered-on-top'),
		link: '/intelligent-safety',
	}, {
		label: t('phase-three'),
		heading: t('science-in-society'),
		description: t('the-final-piece'),
		link: '/science-in-society',
	}], [t]);

	return (
		<section className="accessible">
			<div className="content-wrapper">
				<div className="desktop-screen">
					<h1>{t('making-driving-safe')}</h1>
					<h2>{t('we-have-optimized')}</h2>
				</div>

				<div className="outer-container">
					<div className="inner-container">
						<div className="mobile-screen">
							<h1>{t('making-driving-safe')}</h1>
							<h2>{t('we-have-optimized')}</h2>
						</div>

						<header>
							<ul className="bold">
								{phases.map(({ label }, idx) => {
									const classes = classNames({
										selected: idx === selectedIdx,
									});

									const onClick = () => {
										setSelectedIdx(idx);
									};

									return (
										<li
											key={`${label}-btn`}
											className={classes}
											onClick={onClick}>
											{label}
										</li>
									);
								})}
							</ul>
						</header>

						<aside>
							{phases.map(({ label, heading, description, link }, idx) => {
								const classes = classNames({
									selected: idx === selectedIdx,
								}, 'phase');

								return (
									<div key={`${label}-desc`} className={classes}>
										<h5 className="bold">{heading}</h5>
										<p>{description}</p>
										<Link className="btn-link" to={link}>
											{t('learn-more')}
											<Arrow />
										</Link>
									</div>
								);
							})}
						</aside>

						<div className="graph-wrapper">
							<div className="bars">
								{phases.map(({ label }, idx) => {
									const classes = classNames({
										selected: idx === selectedIdx,
									});

									return (
										<div key={`${label}-bar`} className={classes} />
									);
								})}
							</div>

							<div className="guidelines">
								<div />
								<div />
							</div>

							<div className="benchmark">
								<span className="bold">{t('driver-today')}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default Accessible;
